import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from 'react';
import styled from 'styled-components';
import { Breadcrumb as AntBreadcrumb } from 'antd';
import { RightOutlined as AntRightOutlined } from '@ant-design/icons';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  padding-top: 8px;\n  align-items: center;\n  margin: 0;\n\n  @media only screen and (max-width: ", ") {\n    flex-direction: column;\n    margin-bottom: 0.5em;\n    align-items: flex-start;\n  }\n\n  ", "\n"])), function (props) {
  return props.theme.layout.mainLayoutSection.padding;
}, function (props) {
  var _props$theme$breakpoi;

  return ((_props$theme$breakpoi = props.theme.breakpoints) === null || _props$theme$breakpoi === void 0 ? void 0 : _props$theme$breakpoi.sm) && '576px';
}, function (props) {
  return props.theme.layout.mainLayoutSection.responsivePadding && "\n    @media only screen and (max-width: ".concat(props.theme.breakpoints.sm, ") {\n      padding: ").concat(props.theme.layout.mainLayoutSection.responsivePadding, ";\n    } \n  ");
});
var CustomBreadcrumb = styled(AntBreadcrumb)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  a {\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n\n  .anticon svg {\n    font-size: 10px;\n    margin-bottom: 2.3px;\n  }\n\n  span {\n    color: ", ";\n  }\n\n  span:last-child a {\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.colors[props.color];
});
var BreadcrumbItem = styled(AntBreadcrumb.Item)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n"])));
var RightOutlined = styled(AntRightOutlined)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 20px;\n  stroke: ", ";\n  stroke-width: 100px;\n  width: 20px;\n"])), function (props) {
  return props.theme.colors[props.color];
});

var Breadcrumb = function Breadcrumb(_ref) {
  var _ref$breadcrumb = _ref.breadcrumb,
      breadcrumb = _ref$breadcrumb === void 0 ? [] : _ref$breadcrumb,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      dataTestId = _ref['data-testid'];
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(CustomBreadcrumb, {
    color: color,
    "data-testid": dataTestId,
    separator: /*#__PURE__*/React.createElement(RightOutlined, {
      color: color
    })
  }, breadcrumb.map(function (item) {
    return /*#__PURE__*/React.createElement(BreadcrumbItem, {
      "data-testid": item.id
    }, item.path ? /*#__PURE__*/React.createElement("a", {
      href: item.path
    }, item.name) : item.name);
  })));
};

export default Breadcrumb;